import {
  inscriptionService
} from '../_services'

import i18n from '../i18n.js';


const state = {
  currentInscription: {
    loading: false,
    data: null,
    error: null
  },
  currentOpenExpos: {
    loading: false,
    data: null,
    error: null
  },
  selectedExpo: {
    loading: false,
    data: null,
    error: null
  },
  userInsData: {
    loading: false,
    data: null,
    error: null
  },
  userRedsysForm: {
    loading: false,
    data: null,
    error: null
  },
  userDefaultData: {
    datosInscripcion: {
      expoId: null, //id de la expo seleccionada
      expoData: null, //datos de la exposición una vez elegida
      aceptadasCondiciones: 0, //aceptacion de las condiciones
      userData: null,
      socio: 0,
      socioNumero: null,
      inscripciones: null,
      otrosConceptos: [],
      gruposCria: null,
      parejas: null,
    },
    resetData: false
  },
  saveCurrentInscription: {
    loading: false,
    data: null,
    error: null
  }
}

const actions = {
  getUserRedsysForm({
    commit
  }, datos) {
    return new Promise((resolve, reject) => {
      commit('userRedsysDataReq', true);
      inscriptionService.getUserRedsysForm(datos)
        .then(
          data => {
            commit('userRedsysDataOk', data);
            resolve();
          },
          error => {
            commit('userRedsysDataKo', error);
            reject(error);
          });
    })

  },

  getUserOpenExpos({
    commit
  }, canineId) {

    return new Promise((resolve, reject) => {
      commit('currentOpenExposState', true);
      inscriptionService.getUserOpenExpos(canineId)
        .then(
          data => {
            commit('currentOpenExposOk', data);
            resolve();
          },
          error => {
            commit('currentOpenExposKo', error);
            reject("error al recuperar los datos");
          }
        );
    });
  },

  /* funcion para recoger los datos de una expo relativo a la inscripcion */
  getExpo({
    commit
  }, expoId) {

    commit('selectedExpoState', true);
    return new Promise((resolve, reject) => {
      inscriptionService.getExpo(expoId).then(
        data => {
          commit('selectedExpoOk', data);
          resolve(data);
        },
        error => {
          commit('selectedExpoKo', error);
          reject(error);
        }
      )
    });
  },

  /* funcion para recoger los datos del usuario relativos a la inscripcion */
  getUserInscripcionData({
    commit
  }) {

    commit('userDataState', true);
    return new Promise((resolve, reject) => {
      inscriptionService.getUserInscripcionData().then(
        data => {
          commit('userDataOk', data);
          resolve(true);
        },
        error => {
          commit('userDataKo', error);
          reject(false);
        });
    });
  },


  uploadInscriptionData({
    commit,
    dispatch
  }, datos) {
    commit('saveCurrentInsStatus', true);
    return new Promise((resolve, reject) => {

      inscriptionService.uploadInscriptionData(datos)
        .then(
          data => {
            commit('saveCurrentInsStatusOk', data);
            dispatch('notifier/success', i18n.t('notifier_created_inscription_ok'), {
              root: true
            });
            return resolve(data.data);
          },
          error => {
            console.log("hay una error", error)
            commit('saveCurrentInsStatusKo', error);
            dispatch('notifier/error', i18n.t(error), {
              root: true
            });
            return reject(error);
          });
    })
  },

  /* GRUPO DE CRIA */
  getListaGrupoCria({
    commit
  }, perrosId) {
    return new Promise((resolve, reject) => {
      inscriptionService.getListaGrupoCria(perrosId).then(res => {
          return resolve(res);
        },
        error => {
          console.log("hay una error", error)         
          dispatch('notifier/error', i18n.t(error), {
            root: true
          });
          return reject(error);

        })
    })
  },

  /* PAREJAS */
  getListaParejas({
    commit
  }, perrosId) {
    return new Promise((resolve, reject) => {
      inscriptionService.getListaParejas(perrosId).then(res => {
          return resolve(res);
        },
        error => {
          console.log("hay una error", error)         
          dispatch('notifier/error', i18n.t(error), {
            root: true
          });
          return reject(error);

        })
    })
  }

}

const mutations = {
  /* saveCurrentInscription */
  saveCurrentInsStatus(state, status) {
    state.saveCurrentInscription.loading = status;
  },
  saveCurrentInsStatusOk(state, data) {
    state.saveCurrentInscription.data = data;
    state.saveCurrentInscription.loading = false;
  },
  saveCurrentInsStatusKo(state, error) {
    state.saveCurrentInscription.data = null;
    state.saveCurrentInscription.error = error;
    state.saveCurrentInscription.loading = false;
  },

  /* getUserRedysForm */
  userRedsysDataReq(state, status) {
    state.userRedsysForm.loading = status;
  },
  userRedsysDataOk(state, datos) {
    state.userRedsysForm.data = datos.data;
    state.userRedsysForm.loading = false;

  },
  userRedsysDataKo(state, error) {
    state.userRedsysForm.data = null;
    state.userRedsysForm.error = error;
    state.userRedsysForm.loading = false;
  },

  /* getUserInscripcionData */
  userDataState(state, status) {
    state.userInsData.loading = status;
  },
  userDataOk(state, datos) {   
    state.userInsData.data = datos.data;
    state.userInsData.loading = false;
  },
  userDataKo(state, error) {
    state.userInsData.loading = false;
    state.userInsData.data = null;
    state.userInsData.error = error;
  },

  /* getExpo */
  selectedExpoState(state, status) {
    state.selectedExpo.loading = status;
  },

  selectedExpoOk(state, datos) {
    state.selectedExpo.data = datos.data;
    state.selectedExpo.loading = false;
  },

  selectedExpoKo(state, error) {
    state.selectedExpo.loading = false;
    state.selectedExpo.data = null;
    state.selectedExpo.error = error;
  },

  /* getUserOpenExpos */
  currentOpenExposState(state, status) {
    state.currentOpenExpos.loading = status;
  },

  currentOpenExposOk(state, datos) {
    state.currentOpenExpos.data = datos.data;
    state.currentOpenExpos.loading = false;
  },

  currentOpenExposKo(state, error) {
    state.currentOpenExpos.loading = false;
    state.currentOpenExpos.data = null;
    state.currentOpenExpos.error = error;
  },

  currentInscriptonState(state, status) {
    state.currentInscription.loading = status;
  },
  currentInscriptonOk(state, datos) {
    state.currentInscription.data = datos.data;
    state.currentInscription.loading = false;
  },
  currentInscriptonKo(state, error) {
    state.currentInscription.loading = false;
    state.currentInscription.data = null;
    state.currentInscription.error = error;
  },

  /* actualizar los datos de la actual inscripcion desde INSCRIPTION-NEW.VUE */
  actualizarCurrentInscription(state, datos) {
    state.currentInscription.data = JSON.parse(JSON.stringify(datos));
  },

  /* resetear datos */
  resetCurrentIns(state, status) {
    state.userDefaultData.resetData = status;
  },
}

const getters = {
  getselectedExpoData(state) {
    return JSON.parse(JSON.stringify(state.selectedExpo.data));
  },
  getUserDefaultData(state) {
    return JSON.parse(JSON.stringify(state.userDefaultData));
  },

}


export const inscription = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};